import React from 'react';

const Logo = ({ size = 32 }) => (
  <div className="flex items-center gap-2">
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 12C8 9.79086 9.79086 8 12 8H22V14H14V34H22V40H12C9.79086 40 8 38.2091 8 36V12Z" fill="#1AB6FF"/>
      <path d="M40 36C40 38.2091 38.2091 40 36 40H26V34H34V24H26V18H36C38.2091 18 40 19.7909 40 22V36Z" fill="#1AB6FF"/>
      <rect x="22" y="22" width="10" height="4" fill="#1AB6FF"/>
    </svg>
    <span className="font-display font-bold text-2xl tracking-tight">
      <span style={{ color: '#1AB6FF' }}>Geekynd</span>
      <span className="text-white/90 ml-1 text-base font-medium align-middle">India</span>
    </span>
  </div>
);

export default Logo;
